












import { Vue, Component, Prop } from 'vue-property-decorator'
import InnerContent from './InnerContent.vue'
import IDonutChartData from './IDonutChartData'
import Chart from './Chart.vue'

@Component({
  components: {
    Chart,
    InnerContent
  }
})
export default class DonutChart extends Vue {
  @Prop() private chartData!: IDonutChartData

  data() {
    return { ...this.chartData }
  }
}
